"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_HOW_TO_PAY_FLEX_BACK_CONTENT = void 0;
exports.CREDIT_BUILDER_HOW_TO_PAY_FLEX_BACK_CONTENT = {
    HEADER: 'Choose how you pay Flex',
    SUB_HEADER: 'You can choose whether to have your payment transferred to your property or kept as a deposit in Flex.',
    PAYMENT_LABEL: 'Payment',
    DEPOSIT: {
        TITLE: 'Transfer to property',
        CONTENT: 'We’ll use your initial payment to pay your property. You’ll continue to make your payments to Flex at the time rent is due.'
    },
    CARD: {
        TITLE: 'Keep as deposit',
        CONTENT: 'We’ll keep your initial payment as a deposit. You’ll need to pay Flex back after your rent bill is paid each month. This deposit is refundable.'
    },
    CTA: 'Save'
};
